import { NgModule } from '@angular/core';

import { CustomButtonComponent } from './button.component';

@NgModule({
  imports: [],
  exports: [CustomButtonComponent],
  declarations: [CustomButtonComponent],
  providers: []
})
export class CustomButtonModule {}
